import { Snackbar, TextField } from "@mui/material";
import { useState } from "react";

interface UserIdBoxProps {
	userId: string;
}

const UserIdBox: React.FC<UserIdBoxProps> = ({ userId }) => {
	const [userIdCopied, setUserIdCopied] = useState(false);

	const onClickCopyUserId = async () => {
		try {
			await navigator.clipboard.writeText(userId);
			setUserIdCopied(true);
		} catch (err) {
			console.error("Failed to copy User ID:", err);
		}
	};

	return (
		<>
			<div
				role="button"
				tabIndex={0}
				title="Copy User Id"
				onClick={onClickCopyUserId}
				onKeyDown={(event) => {
					if (event.key === "Enter" || event.key === " ") {
						event.preventDefault();
						onClickCopyUserId();
					}
				}}
				style={{ cursor: "pointer", width: "100%" }}
			>
				<TextField
					label="User Id"
					value={userId}
					disabled
					fullWidth
					sx={{
						pointerEvents: "none",
						"& .MuiInputBase-input": { fontSize: "0.88rem" }
					}}
				/>
			</div>
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				open={userIdCopied}
				autoHideDuration={2000}
				onClose={() => setUserIdCopied(false)}
				message="User Id copied to clipboard"
			/>
		</>
	);
};

export default UserIdBox;
